export default __webpack_public_path__ + "static/media/Panel.9a71ac82.less";